import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { coinsService } from '../../services/coins.service';
import { identificationService } from '../../services/identification.service';
import { authService } from '../../services/auth.service';
@Component({
  selector: 'app-user-identifications',
  templateUrl: './user-identifications.component.html',
  styleUrls: ['./user-identifications.component.scss'],
  standalone: false,
})
export class UserIdentificationCommentsComponent implements OnInit {

  coinId:string;
  coin;
  identifications;
  
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private coinService: coinsService,
    private auth: authService,
    private identificationService: identificationService,
    private dialogRef: MatDialogRef<UserIdentificationCommentsComponent>
  ){
 
  }

  ngOnInit(): void {
  this.getCoinIdentifications();
  }

  getCoinIdentifications(){
    let data = {
      coin_id: this.data,
      user_id: this.auth.userAuthData.user.id
    }
    this.identificationService.getUserCoinIdentification(data).subscribe(res => {
      this.identifications = res.data;
      // this.identifications = this.coin.identifications;
    })
  }


  onClose() {
    this.dialogRef.close();
  }
}
